import React from 'react';
import StopeChart from './StopeChart';

export default function StopeStatistics({ stopeID }) {
  return (
    <div className="flex flex-col w-full h-full bg-transparent overflow-y-auto">
      <div className="px-2.5 py-2 border-b border-yellow-600/20 shrink-0">
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-yellow-400">
          Stope statistics
        </h2>
        {stopeID ? (
          <p className="text-[10px] text-zinc-500 mt-0.5 truncate">
            Filtered to <span className="text-yellow-500/90">{stopeID}</span>
          </p>
        ) : (
          <p className="text-[10px] text-zinc-600 mt-0.5">
            Click a stope with Info (I) to filter these charts.
          </p>
        )}
      </div>
      <div className="flex-1 min-h-0 p-2">
        <StopeChart stopeID={stopeID} />
      </div>
    </div>
  );
}
